// extracted by mini-css-extract-plugin
export default {"loader":"MainLoader_loader__SjXkO","loader-element":"MainLoader_loader-element__9ZBsv","loader4":"MainLoader_loader4__uPdCZ","loader4Round":"MainLoader_loader4Round__fYrCt"};